export class API {
  constructor() {
    this.BASE_URL = "/wp-json/skideal/v1";
    this.REQUESTING_EXTRA_CONTENTS = false;
    this.REQUESTING_AGENT_LOGIN = false;
    this.REQUESTING_QUIZ_SUBMIT = false;
    this.REQUESTING_VACATION = false;
    this.REQUESTING_QUOTE = false;
    this.SENDING_ORDER = false;
    this.REQUESTING_PREVIEW_QUOTE = false;
    this.REQUESTING_HOTEL_PACKAGES = [];
  }

  sites() {
    return this.request("GET", "/sites?website=1", {
      params: ""
    });
  }

  queryVacationPackages(requestData) {
    const url = "/vacation-query-packages";

    return this.request("POST", url, {
      formData: requestData
    });
  }

  hotelPackages(
    id,
    userId,
    siteId = false,
    group = false,
    large = false,
    query = ""
  ) {
    if (!this.REQUESTING_HOTEL_PACKAGES.includes(id)) {
      this.REQUESTING_HOTEL_PACKAGES.push(id);

      let url;

      if (siteId) {
        url = "/hotels/packages/" + id + "/" + userId + "/" + siteId;
      } else {
        url = "/hotels/packages/" + id + "/" + userId;
      }

      if (large) {
        url += "?large=1";

        if (group) {
          url += `&group=${group}`;
        }
      } else if (group) {
        url += `?group=${group}`;
      }

      return this.request("GET", url, {
        params: ""
      });
    }
  }

  hotelMobilePackages(id, userId, siteId = false, group = false, query = "") {
    let url;

    if (siteId) {
      url = "/hotels/mobile-packages/" + id + "/" + userId + "/" + siteId;
    } else {
      url = "/hotels/mobile-packages/" + id + "/" + userId;
    }

    if (group) {
      url += `?group=${group}`;
    }

    return this.request("GET", url, {
      params: ""
    });
  }

  hotelsExtraContents(id, query = "") {
    if (
      !this.REQUESTING_EXTRA_CONTENTS ||
      parseInt(id) !== parseInt(this.REQUESTING_EXTRA_CONTENTS)
    ) {
      this.REQUESTING_EXTRA_CONTENTS = id;
      return this.request("GET", "/hotels/" + id + "/extra-contents", {
        params: {
          query
        }
      });
    }
  }

  sendOrderDetails(order, quoteId) {
    if (!this.SENDING_ORDER) {
      this.SENDING_ORDER = true;
      return this.request("POST", "/order-vacation", {
        json: {
          order: order,
          quoteId: quoteId
        }
      });
    }
  }

  sendAgentQuote(quoteData) {
    if (!this.REQUESTING_QUOTE) {
      this.REQUESTING_QUOTE = true;
      return this.request("POST", "/send-quote", {
        json: {
          quote: quoteData
        }
      });
    }
  }

  previewAgentQuote(quoteData) {
    if (!this.REQUESTING_PREVIEW_QUOTE) {
      this.REQUESTING_PREVIEW_QUOTE = true;
      return this.request("POST", "/preview-quote", {
        json: {
          quote: quoteData
        }
      });
    }
  }

  processAgentLogin(email, password) {
    if (!this.REQUESTING_AGENT_LOGIN) {
      this.REQUESTING_AGENT_LOGIN = true;
      return this.request("POST", "/agent-login", {
        json: {
          email: email,
          password: password
        }
      });
    }
  }

  createSalesforceLead(mappedValues) {
    return this.request("POST", "/leads/create", {
      json: {
        values: mappedValues
      }
    });
  }

  submitQuiz(quizData) {
    if (!this.REQUESTING_QUIZ_SUBMIT) {
      this.REQUESTING_QUIZ_SUBMIT = true;
      return this.request("POST", "/contact-quiz", {
        json: {
          quiz_data: quizData
        }
      });
    }
  }

  buildVacationQuery(vacationParams) {
    if (!this.REQUESTING_VACATION) {
      this.REQUESTING_VACATION = true;
      return this.request("POST", "/build-vacation-query", {
        json: {
          vacation_params: vacationParams
        }
      });
    }
  }

  customerLogin(idNumber, phoneNumber, type, securityCode) {
    return this.request("POST", "/customers/login", {
      json: {
        id_number: idNumber,
        phone_number: phoneNumber,
        type: type,
        security_code: securityCode
      }
    });
  }

  customerLogout() {
    return this.request("POST", "/customers/logout", {});
  }

  customerUpdate(form) {
    return this.request("POST", "/customers/self", {
      json: form
    });
  }

  customerUpdateSurvey(form) {
    return this.request("POST", "/customers/survey", {
      json: form
    });
  }

  ordersSaveLead(packageId, form) {
    return this.request("POST", "/orders/save-lead/" + packageId, {
      json: form
    });
  }

  lazy(slug) {
    return this.request("GET", "/lazy/" + slug);
  }

  request(method, path, config = {}) {
    return this.ajax(this.ajaxOptions(method, path, config)).then(
      resp => resp.data
    );
  }

  ajaxOptions(method, path, { params = null, json = null, formData = null }) {
    const options = {
      type: method,
      url: this.BASE_URL + path
    };

    if (json !== null) {
      options.data = JSON.stringify(json);
      options.contentType = "application/json; charset=utf-8";
    }

    if (formData != null) {
      options.data = formData;
    }

    return options;
  }

  /**
   * Calls jQuery.ajax and returns a ES6 Promise.
   */
  ajax(options) {
    return new Promise(function (resolve, reject) {
      $.ajax(options)
        .done(resolve)
        .fail(reject);
    });
  }
}

export var api = new API();
